interface SvgProps {
  color?: string;
  width?: string;
  height?: string;
}

const CircleWithCurvedLine = ({ width = "26", height = "26" }: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="12.9665"
        cy="12.9999"
        rx="8.75988"
        ry="8.79331"
        transform="rotate(45 12.9665 12.9999)"
        fill="white"
      />
      <path
        d="M7.83622 18.1295C5.0159 15.3092 5.02648 10.726 7.85986 7.89258"
        stroke="#0060DD"
        strokeWidth="1.7386"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CircleWithCurvedLine;
